import React, { useContext } from "react"
import { Row, Col } from "react-bootstrap"

import Back from "../../images/Back.jpg"
import { GlobalAuthContext } from "../../context/authContext"

import "./profile-image-uploader.scss"

const ProfileImageUploader = props => {
  const {
    formState,
    setFormState,
    setErrors,
    setProcessing,
    Upload,
    errors,
    sub_text,
  } = props

  const { state, dispatch } = useContext(GlobalAuthContext)

  const handleProfileImageUploadChange = e => {
    setErrors([])
    setFormState({
      ...formState,
      avatar_name: URL.createObjectURL(e.target.files[0]),
      avatar: URL.createObjectURL(e.target.files[0]),
      image_file: e.target.files[0],
    })

    Upload(
      e.target.files[0],
      setProcessing,
      setErrors,
      dispatch,
      state,
      URL.createObjectURL(e.target.files[0])
    )
  }

  return (
    <div className="profile-image-uploader">
      <Row className="align-items-center ">
        <Col lg="3" md="4">
          <div className="profile-image-preview">
            {!formState.avatar ? (
              <img src={Back} alt={"Back"} />
            ) : (
              <img
                src={formState.avatar_name || formState.avatar}
                alt={
                  formState.first_name || formState.organization_name
                    ? formState.first_name || formState.organization_name
                    : "wdn-profile-image"
                }
              />
            )}
          </div>
        </Col>
        <Col lg="9" md="8">
          <div className="profile-image-uploader__wrapper">
            <h5 className="mb-4">
              {!!!sub_text ? "Profile Image" : " Upload Logo"}
              <span>*</span>
            </h5>
            <label
              className="btn-custom light mb-2 d-flex justify-content-center"
              htmlFor="profile-image-upload"
            >
              Browse
            </label>
            <input
              id="profile-image-upload"
              name="profile-image"
              onChange={handleProfileImageUploadChange}
              type="file"
              accept="image/x-png,image/jpeg, image/jpg"
              hidden
            />
            <p className="mb-4">
              {sub_text
                ? sub_text
                : `Image should be a closeup, portrait, facing straight and can not
              be blur.`}
            </p>
            {errors &&
              Object.keys(errors)
                .slice(0, 1)
                .map((key, value) => {
                  if (errors[key] === errors.errors) {
                    return (
                      <div
                        key={value}
                        className="mb-4 d-flex align-items-center image-error"
                      >
                        {errors[key]}
                      </div>
                    )
                  } else if (errors[key] === errors.message) {
                    return (
                      <div
                        key={value}
                        className="mb-4 d-flex align-items-center image-error"
                      >
                        {errors[key]}
                      </div>
                    )
                  } else if (errors[key] === errors.avatar) {
                    return (
                      <div
                        key={value}
                        className="mb-4 d-flex align-items-center image-error"
                      >
                        {errors[key]}
                      </div>
                    )
                  } else {
                    return ""
                  }
                })}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default ProfileImageUploader
